// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2mXuU","largestCol":"styles_largestCol__3Bor1","smallestCol":"styles_smallestCol__ANsBi"};